/* KLIK v2 "Added to your cart" sheet (package bugs-cart, K-056; PACKAGES §3.1, §1.13).
   window.KlikCartAdded(result, ctx) → Promise
     result = {lines:[{key, variant_id, quantity, title, image, final_line_price, properties}], setId, displayName, pricePaidCents, eta, image}
              (a /cart/add.js response, {items:[…]} or one line, is accepted too)
     ctx    = {family:'kz'|'kd'|'kf'|'ready'|'room', productId, handle}
   Order: open the sheet from `result` (no request; the price is an estimate that already takes the cart's order discount into
   account) → one KlikCart read → the exact amount checkout charges for these lines (their final_line_price minus their share of
   the order-level discount, e.g. LAMMA10), the bag count, the Checkout guard → publish klik_add_to_cart with that same amount
   (published at the latest before any navigation: the /cart fallback, Checkout, View cart, or after 3 s) → dispatch
   klik:cart-added and Motion cart:build / cart:updated. It never navigates, except to /cart when the sheet cannot open.
   Actions (§1.13): Checkout (the one filled button) and View cart (a quiet text link); the X and the scrim close the sheet.
   When the cart holds an unpriced line, Checkout is hidden, View cart becomes the one filled button, and a short note says why
   (the price is still being confirmed, another item needs its options, or the cart could not be checked) in place of the terms line.
   Loaded with defer from snippets/cart-drawer.liquid (which also passes the policy links and this page's cut-out). */
(function (win) {
  'use strict';
  if (!win || win.KlikCartAdded) return;
  var doc = win.document, sheet = null, returnFocus = null, flush = null;
  var ar = function () { return /^ar\b/i.test(doc.documentElement.lang || ''); };
  var t = function (en, arText) { return ar() ? arText : en; };
  var arabicText = /[؀-ۿ]/;
  function root() { return ((win.Shopify && win.Shopify.routes && win.Shopify.routes.root) || '/').replace(/\/?$/, '/'); }
  function el(tag, cls, text) { var n = doc.createElement(tag); if (cls) n.className = cls; if (text != null) n.textContent = text; return n; }
  function tag() { return doc.querySelector('script[data-kcv-terms-url]') || doc.querySelector('script[data-kcv-ph-src]'); }
  // W7 (build-3 track B, 28 Oct 2026): the ONE delivery-date clock (assets/klik-eta.js, window.KlikEta) that the product page
  // and the made-to-order cart lines use too. Loaded on every page from this theme's asset folder, unless a tag already did
  // (snippets/klik-eta.liquid on the cart page, klik-pdp.js on product pages). KLIK_ETA_V: bump it, and the same constant
  // in klik-pdp.js, when klik-eta.js changes; the day part refreshes every cached copy within a day anyway.
  var KLIK_ETA_V = 'w7a';
  function loadEta() {
    if (win.KlikEta || doc.querySelector('script[data-klik-eta-src]')) return;
    var self = doc.querySelector('script[src*="/assets/klik-cart-added.js"]'), src = self && self.getAttribute('src');
    if (!src) return;
    var sc = doc.createElement('script');
    sc.src = src.replace(/klik-cart-added\.js.*$/, 'klik-eta.js?v=' + KLIK_ETA_V + '-' + new Date().toISOString().slice(0, 10).replace(/-/g, ''));
    sc.async = true;
    sc.setAttribute('data-klik-eta-src', '');
    (doc.head || doc.documentElement).appendChild(sc);
  }

  // The exact amount checkout charges, with the riyal glyph (bugs-price-facts' KlikMoney); plain text as the fallback.
  function paintMoney(target, cents) {
    var value = Number(cents) || 0;
    if (win.KlikMoney && typeof win.KlikMoney.node === 'function') {
      try { target.replaceChildren(win.KlikMoney.node(value, { mode: 'exact' })); return; } catch (_) {}
    }
    var whole = value % 100 === 0;
    var amount = (value / 100).toLocaleString('en-US', { minimumFractionDigits: whole ? 0 : 2, maximumFractionDigits: 2 });
    target.textContent = ar() ? amount + ' ريال' : 'SAR ' + amount;
  }
  // The store display name (same rules as snippets/klik-display-title.liquid): no brand word, "Sukun — Bedroom Set" → "Sukun Bedroom Set".
  function displayName(text) {
    var title = String(text || '').replace(/\s+[—–-]\s+Default\x20Title$/i, '').trim();
    if (/^(KLIK|كليك)\s/i.test(title)) title = title.replace(/^(KLIK|كليك)\s+/i, '');
    var parts = title.split(' — ');
    if (parts.length < 2) parts = title.split(' - ');
    if (parts.length >= 2) {
      var left = parts[0].trim(), right = parts[parts.length - 1].trim(), lw = left.split(' '), rw = right.split(' ');
      if (arabicText.test(title)) { if (right === 'طقم طعام') right = 'طاولة طعام'; title = lw.length === 1 ? right + ' ' + left : left; }
      else if (lw.length === 1) title = left + ' ' + right;
      else if (lw[lw.length - 1] === rw[0]) { var rest = right.slice(rw[0].length).trim(); title = rest ? left + ' ' + rest : left; }
      else title = left;
    }
    // buy-fix: the cart's K-066 rule (snippets/klik-display-title.liquid), so the sheet and the set card use one name:
    // "TV Custom Sofa Set" → "TV Sofa Set", «كنب زاوية سيرا تفصيل» → «كنب زاوية سيرا», "Sectional Sofa" → "Corner Sofa".
    if (!/fully custom/i.test(title)) {
      if (arabicText.test(title)) title = title.replace(' تفصيل حسب الطلب', '').replace(' حسب الطلب', '').replace(/ تفصيل$/, '').trim();
      title = title.replace(' Custom ', ' ').replace(/^Custom /, '').trim();
      if (!arabicText.test(title)) title = title.replace('Sectional Sofa', 'Corner Sofa');
    }
    return title;
  }
  function arCount(n) {
    if (n === 1) return 'قطعة واحدة';
    if (n === 2) return 'قطعتان';
    if (n >= 3 && n <= 10) return n + ' قطع';
    return n + ' قطعة';
  }
  function linesOf(result) {
    if (!result) return [];
    if (Array.isArray(result.lines)) return result.lines;
    if (Array.isArray(result.items)) return result.items;
    if (Array.isArray(result)) return result;
    if (result.variant_id || result.id) return [result];
    return [];
  }
  function imageProperty(props) {
    var keys = ['Product image', 'Product Image', 'صورة المنتج', '_KLIK_line_image', '_klik_image'];
    for (var i = 0; i < keys.length; i++) {
      var value = props && props[keys[i]];
      if (typeof value === 'string' && /^https:\/\/(cdn\.shopify\.com|klikdecor\.com|ar\.klikdecor\.com)\//.test(value)) return value;
    }
    return '';
  }
  // pre-cart (CV-14): the fabric of the set's lead line when the picture is the product as pictured: its fabric photo and its
  // name without codes. None when a line carries its configured image, when the line or the studio's fabric card says
  // "as pictured" (.kff-current.is-pic on every card), or when the line names no fabric. Display only.
  // The studio's own "as pictured" fabric (KlikMaterialLibrary's original item on the page's configurator root): the line's
  // fabric photo or code is that one. Read only; null when the page has no studio library.
  function studioPictured(img, props) {
    try {
      var lib = win.KlikMaterialLibrary;
      if (!lib || typeof lib.catalog !== 'function') return false;
      var file = function (u) { return String(u || '').split('?')[0].split('/').pop().toLowerCase(); };
      var code = '';
      Object.keys(props).forEach(function (k) { if (!code && /fabric code|كود القماش/i.test(k)) code = String(props[k] || '').trim().toUpperCase(); });
      var roots = Array.prototype.filter.call(doc.querySelectorAll('[data-product-id]'), function (n) { return n.klikFabricLibrary; });
      for (var i = 0; i < roots.length; i++) {
        var items = lib.catalog(roots[i]) || [];
        var o = items.filter(function (x) { return x && (x.original || x.key === 'original'); })[0];
        if (!o) continue;
        if (file(img) && (file(o.image) === file(img) || file(o.textureUrl) === file(img))) return true;
        var hay = [o.sku, o.code, o.name, o.label].map(function (v) { return String(v || ''); }).join(' ').toUpperCase();
        if (code && code.length > 3 && hay.indexOf(code) >= 0) return true;
        if (code && file(o.image || o.textureUrl).toUpperCase().indexOf(code) >= 0) return true;
      }
    } catch (_) {}
    return false;
  }
  function chosenFabric(lines) {
    if (lines.some(function (line) { return imageProperty(line.properties || {}); })) return null;
    var lead = lines.filter(function (line) { return line.properties && line.properties._KLIK_design; })[0] || lines.filter(function (line) { return !isExtra(line); })[0] || lines[0];
    var props = (lead && lead.properties) || {}, img = '', name = '', pictured = false;
    Object.keys(props).forEach(function (k) {
      var key = String(k).toLowerCase().trim(), v = String(props[k] == null ? '' : props[k]).trim();
      // build-1 W3: on a sofa line the fabric photo and its type are hidden rows ("_Fabric photo / …"); they still name the swatch
      if (!v || (key.charAt(0) === '_' && !/^_fabric photo/.test(key))) return;
      if (/photo type|نوع صورة القماش/.test(key)) { if (/original|الأصلية/i.test(v)) pictured = true; }
      else if (/^fabric photo|صورة القماش/.test(key)) { if (!img && /^https:\/\//.test(v)) img = v; }
      else if (!name && (/^(sofa fabric|قماش الكنبة|fabric|القماش|upholstery)$/.test(key) || key === 'ال' + 'تنج' + 'يد')) name = v; // (the upholstery key, spelled in parts for the copy lint)
    });
    if (/as pictured|as photographed|كما في الصورة/i.test(name)) pictured = true;
    var cards = doc.querySelectorAll('.kff-current');
    if (cards.length && Array.prototype.every.call(cards, function (card) { return card.classList.contains('is-pic'); })) pictured = true;
    if (!pictured && img && studioPictured(img, props)) pictured = true;
    // The cart (server-rendered) cannot tell; it reads this per-line note to leave the swatch off (klik-native-cart-display.js).
    if (pictured && lead && lead.key) { try { var seen = JSON.parse(win.localStorage.getItem('kcv-fab-pic') || '{}'); seen[lead.key] = 1; var keys = Object.keys(seen); if (keys.length > 40) delete seen[keys[0]]; win.localStorage.setItem('kcv-fab-pic', JSON.stringify(seen)); } catch (_) {} }
    if (pictured || !img || !name) return null;
    var clean = [];
    name.replace(/&amp;/g, '&').split(' · ').forEach(function (part) {
      var words = part.split(' ').filter(function (w) { return !(w === w.toUpperCase() && /\d/.test(w)); }).join(' ').trim();
      if (words && clean.indexOf(words) < 0) clean.push(words);
    });
    return clean.length ? { img: img, name: clean.join(' · ') } : null;
  }
  // The picture: an explicit image, the configured image property, this product page's studio cut-out (data on the script
  // tag, only when the cut-out exists), then the line images.
  function imageCandidates(lines, result, ctx) {
    var list = [];
    var push = function (url) { if (url && list.indexOf(url) < 0) list.push(url); };
    push(result && result.image); push(ctx && ctx.image);
    lines.forEach(function (line) { push(imageProperty(line.properties || {})); });
    // A set from a builder (_klik_design shared by its lines): the design's own cut-out, as on the cart's set card
    // (klik-ph-<design>-400.webp next to this script); a design without a cut-out falls through on error.
    var setDesign = '';
    if (lines.length && lines.every(function (line) { var d = line.properties && line.properties._klik_design; if (d && !setDesign) setDesign = String(d); return !!d && String(d) === setDesign; }) && /^[a-z0-9-]+$/.test(setDesign)) {
      var self = doc.querySelector('script[src*="klik-cart-added.js"]'), src = self && self.getAttribute('src');
      if (src) push(src.replace(/klik-cart-added\.js[^/]*$/, 'klik-ph-' + setDesign + '-400.webp'));
    }
    var ph = doc.querySelector('script[data-kcv-ph-src]');
    if (ph) {
      var handle = ph.getAttribute('data-kcv-ph-handle'), pid = ph.getAttribute('data-kcv-ph-product');
      var first = lines[0] || {}, design = first.properties && (first.properties._klik_design || '');
      // A set made in a builder shows its design (_klik_design); otherwise the product of this page.
      var mine = design ? design === handle : ((ctx && (ctx.handle === handle || String(ctx.productId) === pid)) || lines.every(function (line) { return String(line.product_id) === pid; }));
      if (mine) push(ph.getAttribute('data-kcv-ph-src'));
    }
    lines.forEach(function (line) { push(line.image || (line.featured_image && line.featured_image.url)); });
    return list.map(function (url) { return /^\/\//.test(url) ? 'https:' + url : url; });
  }
  function sized(url, width) {
    if (!url) return '';
    try { var u = new URL(url, win.location.href); if (/cdn\.shopify\.com|\/cdn\/shop\//.test(u.href)) u.searchParams.set('width', String(width)); return u.href; } catch (_) { return url; }
  }
  // Same words as the cart lines (snippets/cart-item.liquid).
  // Made to order: the one rule, word for word as the cart prints it (klik-fact mto_lead long via window.KlikFacts; PACKAGES
  // owner decision 2026-10-22: no approval condition in lead times), label joined by " · ", the number on one line.
  function mtoLine() {
    var facts = win.KlikFacts, long = facts && facts.mto_lead && typeof facts.mto_lead.long === 'string' ? facts.mto_lead.long.trim() : '';
    if (!long || arabicText.test(long) !== ar()) long = t('Made to order: delivered in up to 15 business days.', 'تفصيل حسب الطلب: يصلك خلال 15 يوم عمل كحد أقصى.');
    return long.replace(': ', ' · ').replace(/\.$/, '').replace('15 business days', '15 business days').replace('15 يوم عمل', '15 يوم عمل'); // v2-copy-lint: ignore (only keeps the number of the full rule on one line)
  }
  // W7: made to order names its date, from the one clock: "Made to order · delivered by Wed 18 Nov at the latest"
  // («تفصيل حسب الطلب · يصلك بحلول الأربعاء 18 نوفمبر كحد أقصى»), computed when the sheet is filled, never stored on the
  // line. Without the clock (still loading, ?klik-eta=0) the rule's words above; klik:eta-ready fills an open sheet.
  function datedLine() {
    var line = mtoLine(), E = win.KlikEta;
    if (!E || !E.enabled || typeof E.label !== 'function') return line;
    try { return line.split(' · ')[0] + ' · ' + E.label(15, { form: 'line', nbsp: true }); } catch (_) { return line; }
  }
  function etaFor(result, ctx) {
    // a ready-to-ship add from the product page passes its own line ("Usually delivered in 1–7 business days") without
    // ctx.family: the 1–7 range marks it ready, so the line gets the truck icon, never the made-to-order tape (brand rollout)
    if (result && typeof result.eta === 'string' && result.eta) {
      var given = (ctx && ctx.family === 'ready') || /(^|\D)1\D{0,3}7(\D|$)/.test(result.eta) ? 'ready' : 'custom';
      return { text: given === 'custom' && win.KlikEta && win.KlikEta.enabled ? datedLine() : result.eta, route: given };
    }
    return ctx && ctx.family === 'ready'
      ? { route: 'ready', text: t('Ready to ship · 1⁠–⁠7 business days', 'جاهز للتوصيل · خلال ⁦1–7⁩ أيام عمل') }
      : { route: 'custom', text: datedLine() };
  }

  /* ---------- the amount: what checkout charges for these lines ---------- */
  function lineFinal(line) {
    var value = Number(line.final_line_price);
    if (!Number.isFinite(value)) value = (Number(line.final_price || line.price) || 0) * (Number(line.quantity) || 1);
    return value;
  }
  function lineOriginal(line) {
    var value = Number(line.original_line_price);
    return Number.isFinite(value) && value > 0 ? value : lineFinal(line);
  }
  function orderDiscounts(cart) {
    return ((cart && cart.cart_level_discount_applications) || []).filter(function (app) { return Number(app.total_allocated_amount) > 0; });
  }
  function dealLabel(apps) {
    var seen = [];
    apps.forEach(function (app) {
      var title = String(app.title || app.code || '').trim();
      if (!title || seen.some(function (s) { return s.title.toLowerCase() === title.toLowerCase(); })) return;
      seen.push({ title: title, code: app.type === 'discount_code' || !!app.code });
    });
    return seen.map(function (s) { return s.code ? t(s.title + ' applied', 'الرمز ' + s.title + ' مُطبّق') : s.title; }).join(' · ');
  }
  // pre-cart (BV-1): the order discount per line key, by largest remainder in integers (snippets/cart-item.liquid's rule):
  // value × discount ÷ subtotal floored, the halalas left over to the largest remainders, a tie to the earlier line.
  function orderShares(cart, discount, subtotal) {
    var out = {}, items = (cart && cart.items) || [];
    if (!(discount > 0) || !(subtotal > 0)) return out;
    var rows = items.map(function (item, i) {
      var v = Number(item.final_line_price) || 0, p = v * discount;
      return v > 0 ? { i: i, key: item.key, v: v, fl: Math.floor(p / subtotal), rm: p % subtotal } : { i: i, key: item.key, v: v, fl: 0, rm: -1 };
    });
    var left = discount - rows.reduce(function (total, r) { return total + r.fl; }, 0);
    rows.filter(function (r) { return r.rm >= 0; }).sort(function (a, b) { return b.rm - a.rm || a.i - b.i; })
      .forEach(function (r, n) { if (n < left) r.fl += 1; });
    rows.forEach(function (r) { if (r.key) out[r.key] = Math.max(0, Math.min(r.v, r.fl)); });
    return out;
  }
  // Exact, from a fresh cart: the lines' final_line_price (line discounts included) minus their share of the order-level
  // discounts, allocated by line value as checkout allocates them. The lines are matched by key; a line that is not found
  // (merged or changed) keeps the add response's numbers.
  // A line whose key changed after the add (the cart re-keyed it) is found again by variant, quantity and properties, so it
  // takes the cart's own share instead of a separately rounded one (a multi-line set once read 1 halala below checkout).
  function sameLine(item, line) {
    return String(item.variant_id) === String(line.variant_id) && Number(item.quantity) === Number(line.quantity) &&
      JSON.stringify(item.properties || {}) === JSON.stringify(line.properties || {});
  }
  function settle(lines, cart) {
    var byKey = {}, used = {}, items = (cart && cart.items) || [];
    items.forEach(function (item) { byKey[item.key] = item; });
    lines.forEach(function (line) { if (line.key && byKey[line.key]) used[line.key] = true; });
    var picked = lines.map(function (line) {
      if (line.key && byKey[line.key]) return byKey[line.key];
      var hit = items.filter(function (item) { return !used[item.key] && sameLine(item, line); })[0];
      if (hit) used[hit.key] = true;
      return hit || line;
    });
    var sum = picked.reduce(function (total, line) { return total + lineFinal(line); }, 0);
    var original = picked.reduce(function (total, line) { return total + lineOriginal(line); }, 0);
    var subtotal = Number(cart && cart.items_subtotal_price);
    if (!(subtotal > 0)) subtotal = ((cart && cart.items) || []).reduce(function (total, item) { return total + lineFinal(item); }, 0);
    var apps = orderDiscounts(cart);
    var discount = apps.reduce(function (total, app) { return total + Number(app.total_allocated_amount); }, 0);
    // Shopify's own allocation when the cart exposes it (total_discount beyond the line-level part, the number the cart's
    // lines print), else by line value as checkout allocates it.
    // buy-fix CO-10: the cart's rule (snippets/cart-item.liquid): each line's share is its value × discount ÷ subtotal, rounded,
    // so the sheet, the set card and the lines show the same figure in EN and AR and after any other cart change.
    // pre-cart (BV-1): by largest remainder over every cart line (orderShares, the cart's rule), so the shares add up to the
    // discount and one set alone prints the cart total to the halala; a line not found in the cart keeps the rounded rule.
    var shares = orderShares(cart, discount, subtotal);
    var share = subtotal > 0 && discount > 0 ? Math.min(sum, picked.reduce(function (total, line) { return total + (line.key && Object.prototype.hasOwnProperty.call(shares, line.key) ? shares[line.key] : Math.round(lineFinal(line) * discount / subtotal)); }, 0)) : 0;
    var lineApps = [];
    picked.forEach(function (line) { (line.line_level_discount_allocations || []).forEach(function (a) { if (a.discount_application && Number(a.amount) > 0) lineApps.push(a.discount_application); }); });
    var all = lineApps.concat(share > 0 ? apps : []);
    return { paid: Math.max(0, sum - share), was: original, deal: dealLabel(all), picked: picked, exact: true };
  }
  // Before the read: the last cart's order-discount ratio (shared store), else the active campaign (an ORDER discount that the
  // cart applies), else the lines as added. pricePaidCents from an adopter wins.
  function estimate(lines, result) {
    var sum = lines.reduce(function (total, line) { return total + lineFinal(line); }, 0);
    var original = lines.reduce(function (total, line) { return total + lineOriginal(line); }, 0);
    if (result && Number(result.pricePaidCents) > 0) return { paid: Number(result.pricePaidCents), was: original, deal: '', exact: false };
    var last = win.KlikCart && typeof win.KlikCart.peek === 'function' ? win.KlikCart.peek() : null;
    var apps = orderDiscounts(last), subtotal = Number(last && last.items_subtotal_price);
    if (apps.length && subtotal > 0) {
      var discount = apps.reduce(function (total, app) { return total + Number(app.total_allocated_amount); }, 0);
      return { paid: sum - Math.round(sum * discount / subtotal), was: original, deal: dealLabel(apps), exact: false };
    }
    var config = null;
    try { config = JSON.parse((doc.querySelector('[data-kc-config]') || {}).textContent || 'null'); } catch (_) {}
    if (config && config.autoApply !== false && config.discountClass === 'ORDER' && win.KlikMoney && typeof win.KlikMoney.campaign === 'function') {
      var c = win.KlikMoney.campaign(sum);
      // Not "applied" before the cart read confirms the code is on the cart: "With LAMMA10" until then.
      if (c && c.active && c.saving > 0) return { paid: c.current, was: original, deal: t('With ' + c.code, 'مع الرمز ' + c.code), exact: false, campaign: true };
    }
    return { paid: sum, was: original, deal: '', exact: false };
  }

  /* ---------- analytics (once per add, with the amount checkout charges) ---------- */
  function payloadFor(lines, result, ctx) {
    return {
      family: (ctx && ctx.family) || 'unknown',
      productId: String((ctx && ctx.productId) || (lines[0] && lines[0].product_id) || ''),
      handle: (ctx && ctx.handle) || (lines[0] && lines[0].handle) || '',
      lines: lines.map(function (line) { return { variant_id: line.variant_id || line.id, quantity: Number(line.quantity) || 1, final_line_price: Number(line.final_line_price) || 0 }; }),
      valueCents: 0,
      currency: 'SAR',
      setId: (result && result.setId) || null,
      preview: !!win.KlikAnalyticsSuppressed
    };
  }
  function publisher(payload) {
    var done = false, timer = null;
    function send(valueCents) {
      if (done) return payload;
      done = true; win.clearTimeout(timer);
      payload.valueCents = Math.max(0, Math.round(Number(valueCents) || 0));
      try { if (win.Shopify && win.Shopify.analytics && typeof win.Shopify.analytics.publish === 'function') win.Shopify.analytics.publish('klik_add_to_cart', payload); } catch (_) { /* analytics never blocks the sheet */ }
      return payload;
    }
    return { send: send, arm: function (fallbackCents) { timer = win.setTimeout(function () { send(fallbackCents()); }, 3000); }, get done() { return done; } };
  }

  /* ---------- the sheet ---------- */
  function build() {
    if (sheet) return sheet;
    sheet = el('dialog', 'kcv-sheet');
    sheet.setAttribute('aria-labelledby', 'KcvSheetTitle');
    sheet.dataset.klikCartAdded = '';
    sheet.innerHTML =
      '<div class="kcv-sheet__panel" data-kcv-panel>' +
        '<span class="kcv-sheet__grab" aria-hidden="true"></span>' +
        '<header class="kcv-sheet__head"><h2 class="kcv-sheet__title" id="KcvSheetTitle" tabindex="-1"></h2>' +
          '<button type="button" class="kcv-sheet__close" data-kcv-close><svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6 6 18" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg><span class="visually-hidden"></span></button></header>' +
        '<div class="kcv-sheet__body">' +
          '<div class="kcv-sheet__item">' +
            '<div class="kcv-sheet__media"><img alt="" width="400" height="300" decoding="async" hidden></div>' +
            '<div class="kcv-sheet__text"><p class="kcv-sheet__name"></p><p class="kcv-sheet__what"></p><p class="kcv-fabric" data-kcv-fabric hidden><img class="kcv-fabric__sw" alt="" width="24" height="24" decoding="async"><span></span></p><p class="kcv-eta" data-route></p></div>' +
          '</div>' +
          '<dl class="kcv-sheet__paid" aria-live="polite"><dt></dt><dd><span class="kcv-price" data-kcv-paid></span><s class="kcv-price kcv-price--was" data-kcv-was hidden></s></dd></dl>' +
          '<p class="kcv-sheet__vat"><span class="kcv-sheet__deal" data-kcv-deal hidden><svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="m5 12.5 4.2 4.2L19 7" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg><span></span></span><span data-kcv-vat></span></p>' +
          '<p class="kcv-sheet__hold" data-kcv-hold role="status" hidden><svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><circle cx="12" cy="12" r="9" fill="none" stroke="currentColor" stroke-width="1.5"/><path d="M12 11v5.5M12 7.6v.4" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg><span></span></p>' +
          '<div class="kcv-sheet__actions">' +
            '<form action="' + root() + 'cart" method="post" class="kcv-sheet__checkout" data-kcv-checkout-form><button type="submit" name="checkout" class="kcv-btn kcv-btn--primary"></button></form>' +
            '<a class="kcv-link kcv-sheet__view" data-kcv-view href="' + root() + 'cart"></a>' +
          '</div>' +
          '<p class="kcv-sheet__terms"></p>' +
        '</div>' +
      '</div>';
    doc.body.appendChild(sheet);
    sheet.querySelector('[data-kcv-close]').addEventListener('click', close);
    sheet.addEventListener('click', function (event) { if (event.target === sheet) close(); });
    sheet.addEventListener('cancel', function (event) { event.preventDefault(); close(); });
    // the add is published before the shopper leaves the page from here
    sheet.querySelector('[data-kcv-checkout-form]').addEventListener('submit', function (event) { if (!agreed()) { event.preventDefault(); return; } if (flush) flush(); });
    sheet.querySelector('[data-kcv-view]').addEventListener('click', function () { if (flush) flush(); });
    sheet.addEventListener('close', function () {
      doc.documentElement.classList.remove('kcv-sheet-open');
      if (returnFocus && returnFocus.isConnected && typeof returnFocus.focus === 'function') returnFocus.focus({ preventScroll: true });
      returnFocus = null;
    });
    return sheet;
  }
  function close() {
    if (!sheet || !sheet.open) return;
    var reduce = win.matchMedia && win.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) { sheet.close(); return; }
    sheet.classList.add('is-closing');
    win.setTimeout(function () { sheet.classList.remove('is-closing'); if (sheet.open) sheet.close(); }, 260);
  }
  // buy-fix SE-13: one consent rule for the page, the drawer and this sheet. While the owner switch keeps the required
  // tick-box (data-kcv-terms-required on this script tag, from klik-cart-assurance 'terms-required'), the sheet shows the
  // same box above Checkout and Checkout waits for it; otherwise the passive line under the buttons.
  function termsRequired() { var s = tag(); return !!(s && s.getAttribute('data-kcv-terms-required') === 'true'); }
  function agreed() {
    if (!termsRequired() || !sheet) return true;
    var box = sheet.querySelector('[data-kcv-agree]');
    if (!box || box.checked) return true;
    var error = sheet.querySelector('[data-kcv-agree-error]');
    if (error) { error.textContent = t('Tick the box to agree to the Terms and Returns policy, then check out.', 'ضع علامة للموافقة على الشروط وسياسة الإرجاع، ثم أتمّ الطلب.'); error.hidden = false; }
    box.setAttribute('aria-invalid', 'true');
    box.focus();
    return false;
  }
  function terms(node) {
    if (termsRequired()) {
      var src = tag();
      var tUrl = (src && src.getAttribute('data-kcv-terms-url')) || '/policies/terms-of-service';
      var rUrl = (src && src.getAttribute('data-kcv-returns-url')) || '/policies/refund-policy';
      var label = el('label', 'kcv-sheet__agree'), box = el('input');
      box.type = 'checkbox'; box.setAttribute('data-kcv-agree', ''); box.id = 'KcvSheetAgree';
      box.addEventListener('change', function () { if (box.checked) { box.removeAttribute('aria-invalid'); var e = sheet && sheet.querySelector('[data-kcv-agree-error]'); if (e) e.hidden = true; } });
      var l1 = el('a', null, t('Terms', 'الشروط')); l1.href = tUrl;
      var l2 = el('a', null, t('Refund policy', 'سياسة الإلغاء والإرجاع')); l2.href = rUrl;
      var text = el('span');
      if (ar()) text.append('أوافق على ', l1, ' و', l2, '.'); else text.append('I agree to the ', l1, ' and ', l2, '.');
      label.append(box, text);
      var error = el('span', 'kcv-sheet__agree-error'); error.setAttribute('data-kcv-agree-error', ''); error.setAttribute('role', 'alert'); error.hidden = true;
      node.replaceChildren(label, error);
      node.classList.add('kcv-sheet__terms--agree');
      // above Checkout, the box the shopper must tick
      var actions = sheet && sheet.querySelector('.kcv-sheet__actions');
      if (actions && node.nextElementSibling !== actions) actions.parentNode.insertBefore(node, actions);
      return;
    }
    var source = tag();
    var termsUrl = (source && source.getAttribute('data-kcv-terms-url')) || '/policies/terms-of-service';
    var returnsUrl = (source && source.getAttribute('data-kcv-returns-url')) || '/policies/refund-policy';
    var a1 = el('a', null, t('Terms', 'الشروط')); a1.href = termsUrl;
    // conversion W8 (28 Oct 2026): the same words as the cart's terms line (klik-cart-assurance 'terms'): the rule and its remedy
    var a2 = el('a', null, t('Refund policy', 'سياسة الإلغاء والإرجاع')); a2.href = returnsUrl;
    // build-3 track B: the link keeps its colon (and in Arabic its «و») on one line. The links are inline-block for their tap
    // height, so a line could wrap right after the link and start with ":", or leave «و» alone at a line's end.
    var a2c = el('span', 'kcv-nowrap');
    if (ar()) { a2c.append('و', a2, ':'); node.replaceChildren('بإتمام الطلب، فأنت توافق على ', a1, ' ', a2c, ' لا إرجاع بعد التوصيل، ونصلح القطع المعيبة أو نستبدلها.'); }
    else { a2c.append(a2, ':'); node.replaceChildren('By checking out, you agree to our ', a1, ' and ', a2c, ' no returns after delivery; faulty pieces are repaired or replaced.'); }
  }
  // The price block: "⃁4,138.20  ⃁4,598" (struck) and "✓ LAMMA10 applied · VAT included"; "Confirming…" while nothing is priced.
  function paintPrice(amount) {
    if (!sheet) return;
    var paid = sheet.querySelector('[data-kcv-paid]'), was = sheet.querySelector('[data-kcv-was]'), deal = sheet.querySelector('[data-kcv-deal]');
    var confirming = !(amount.paid > 0);
    if (confirming) {
      // no price for these lines yet: "Confirming…" while DPO prices a new configuration, "Still confirming" after ~20 s,
      // "Options needed" for a base product that cannot be priced until its options are chosen; build-1 W6: a made-to-order
      // base at SAR 0 (no configuration) is priced in its 3D studio, which the hold note links to
      var words = amount.reason === 'studio' ? ['Price in the 3D studio', 'السعر في الاستوديو ثلاثي الأبعاد'] : amount.reason === 'options' ? ['Options needed', 'الخيارات غير مكتملة'] : amount.reason === 'still' ? ['Still confirming', 'ما زلنا نؤكد السعر'] : ['Confirming…', 'جارٍ التأكيد…'];
      paid.textContent = t(words[0], words[1]); paid.dataset.state = 'confirming';
    }
    else { paintMoney(paid, amount.paid); paid.dataset.state = amount.exact ? 'exact' : 'estimate'; }
    var struck = !confirming && amount.was > amount.paid;
    was.hidden = !struck;
    if (struck) { paintMoney(was, amount.was); was.insertBefore(el('span', 'visually-hidden', t('Price before discount ', 'السعر قبل الخصم ')), was.firstChild); }
    deal.hidden = confirming || !amount.deal;
    deal.lastElementChild.textContent = amount.deal || '';
    sheet.querySelector('[data-kcv-vat]').textContent = confirming ? '' : (amount.deal ? '· ' : '') + t('VAT included', 'شامل الضريبة');
    sheet.querySelector('.kcv-sheet__paid').setAttribute('aria-busy', String(!amount.exact));
  }
  // Room sets (K-009, SE-15): the delivery that the cart and checkout add, by the cart page's rule (klik-cart-assurance
  // 'reassure'): a cart with a bedroom set is free from the bedroom threshold, else one with a dining set from the dining one,
  // compared with the basket total after discounts. Fee and threshold come from this page's delivery line
  // (klik-room-delivery-copy: the delivery_rule entries). No line for other families, without a page rule, or when the cart
  // is ruled by the other room kind (the cart states that case).
  // The set products (tags klik-bedroom-set / klik-dining-set) are the "-bedroom-set" / "-dining-set" handles; handles are the
  // same on both hosts, product_type is translated on the Arabic one.
  function roomKind(cart) {
    var items = (cart && cart.items) || [];
    var has = function (kind) { return items.some(function (item) { return new RegExp('-' + kind + '-set$').test(String(item.handle || '')) || new RegExp('^' + kind + ' set$', 'i').test(String(item.product_type || '').trim()); }); };
    return has('bedroom') ? 'bedroom' : has('dining') ? 'dining' : '';
  }
  function paintDelivery(cart, ctx) {
    if (!sheet) return;
    var old = sheet.querySelector('[data-kcv-delivery]');
    if (old) old.remove();
    // ctx.family is 'room' from the studio and '' from the product page's as-pictured add (klik-pdp.js); the page rule below
    // exists only on room product pages.
    if (!cart || (ctx && ctx.family && ctx.family !== 'room')) return;
    var rule = doc.querySelector('[data-delivery-line][data-rule="threshold"][data-threshold]'), kind = roomKind(cart);
    if (!rule || !kind || (rule.dataset.kind && rule.dataset.kind !== kind)) return;
    var fee = Number(rule.dataset.fee) || 0, threshold = Number(rule.dataset.threshold) || 0, total = Number(cart.total_price);
    if (!(fee > 0) || !(threshold > 0) || !Number.isFinite(total)) return;
    var left = threshold - total, line = el('p', 'kcv-sheet__vat kcv-sheet__delivery'), text = el('span');
    line.dataset.kcvDelivery = '';
    if (left > 0) {
      var money = function (cents) { var b = el('bdi', 'kcv-nowrap'); paintMoney(b, cents); return b; };
      if (ar()) text.append('التوصيل ', money(fee), ' · أضف ', money(left), ' للتوصيل المجاني');
      else text.append('Delivery ', money(fee), ' · add ', money(left), ' more for free delivery');
    } else text.textContent = t('Free delivery and installation on this order', 'التوصيل والتركيب مجاني لهذا الطلب');
    line.appendChild(text);
    var vat = sheet.querySelector('.kcv-sheet__vat');
    vat.parentNode.insertBefore(line, vat.nextSibling);
  }
  // buy-fix (owner: "the main item shown was table not the main sofa set"): the cart's rule (snippets/cart-item.liquid). A
  // table or ottoman added with a sofa-family set is an extra: named and pictured after the main piece, left out of
  // "Set of N pieces" and counted after it ("+ 1 table"). Main pieces read in design order (_KLIK_design on line 1, then
  // _KLIK_design_line / _KLIK_room_piece), whatever order the add response or the cart lists them in.
  var EXTRA = /^clk-(coffee-table|end-table|ottoman)-/;
  function handleOf(line) { return String((line && (line.handle || (String(line.url || '').match(/\/products\/([^/?#]+)/) || [])[1])) || ''); }
  function isExtra(line) { return EXTRA.test(handleOf(line)); }
  function seqOf(line) { var p = (line && line.properties) || {}; if (p._KLIK_design) return 0; var n = Number(p._KLIK_design_line || p._KLIK_room_piece); return n > 0 && n < 900 ? n : 900; }
  function ordered(lines) {
    var main = lines.some(function (line) { return !isExtra(line); });
    return lines.map(function (line, i) { return { line: line, i: i, x: main && isExtra(line) ? 1 : 0 }; })
      .sort(function (a, b) { return (a.x - b.x) || (seqOf(a.line) - seqOf(b.line)) || (a.i - b.i); })
      .map(function (entry) { return entry.line; });
  }
  function extrasText(tables, ottomans) {
    var parts = [];
    if (tables) parts.push(ar() ? (tables === 1 ? 'طاولة واحدة' : tables === 2 ? 'طاولتان' : tables <= 10 ? tables + ' طاولات' : tables + ' طاولة') : tables + (tables === 1 ? ' table' : ' tables'));
    if (ottomans) parts.push(ar() ? (ottomans === 1 ? 'بوف واحد' : ottomans === 2 ? 'بوفان' : ottomans + ' بوفات') : ottomans + (ottomans === 1 ? ' ottoman' : ' ottomans'));
    return parts.join(' + ');
  }
  function fill(lines, result, ctx, amount) {
    lines = ordered(lines);
    var node = build(), first = lines[0] || {};
    var props = first.properties || {};
    // A set counts only its own lines (same grouping as the cart card), so a stray base line added with it is not a "piece".
    var setId = result && result.setId ? String(result.setId) : '';
    var inSet = setId ? lines.filter(function (line) {
      var p = line.properties || {};
      return [p._KLIK_room_set, p._KLIK_set_id, p._klik_configuration].some(function (v) { return v != null && String(v) === setId; });
    }) : [];
    var counted = inSet.length ? inSet : lines, hasMain = counted.some(function (line) { return !isExtra(line); });
    var qty = function (line) { return Number(line.quantity) || 1; };
    var pieces = 0, tables = 0, ottomans = 0;
    counted.forEach(function (line) {
      if (hasMain && isExtra(line)) { if (/ottoman|pouf/.test(handleOf(line))) ottomans += qty(line); else tables += qty(line); }
      else pieces += qty(line);
    });
    // a ready set is ONE cart line ("7-Seater"): count its pieces from "1 × 3-seat sofa + 1 × 2-seat sofa + 2 × armchair"
    if (pieces <= 1 && counted.length === 1) {
      var conf = String(props.Configuration || props['التكوين'] || ''), counts = 0;
      conf.replace(/(\d+)\s*[×x]\s/g, function (m, d) { counts += Number(d); return m; });
      if (counts > 1) pieces = counts;
    }
    var extras = extrasText(tables, ottomans);
    var isSet = (!!setId || lines.length > 1) && (pieces > 1 || !!extras);
    var name = displayName((result && result.displayName) || props['Room selection'] || props['المجموعة'] || first.product_title || first.title);
    var what = isSet
      ? (extras && pieces <= 1 ? t('With ' + extras, 'مع ' + extras.replace('طاولتان', 'طاولتين').replace('بوفان', 'بوفين')) : t('Set of ' + pieces + (pieces === 1 ? ' piece' : ' pieces'), 'طقم من ' + arCount(pieces).replace('قطعتان', 'قطعتين')) + (extras ? ' + ' + extras : ''))
      : (variantLabel(first) || (pieces > 1 ? t(pieces + ' × added', 'تمت إضافة ' + pieces) : ''));
    var eta = etaFor(result, ctx);
    var images = imageCandidates(lines, result, ctx);
    var image = images[0] || '';
    node.querySelector('#KcvSheetTitle').textContent = t('Added to your cart', 'أُضيف إلى سلتك');
    node.querySelector('[data-kcv-close] .visually-hidden').textContent = t('Close', 'إغلاق');
    node.querySelector('.kcv-sheet__name').textContent = name;
    var whatNode = node.querySelector('.kcv-sheet__what'); whatNode.textContent = what; whatNode.hidden = !what;
    var etaNode = node.querySelector('.kcv-eta'); etaNode.textContent = eta.text; etaNode.dataset.route = eta.route;
    // pre-cart (CV-14): beside the as-pictured photo, the fabric the shopper chose ("Your fabric: Silver · Charlotte Jacquard").
    var fabric = chosenFabric(lines), fabricNode = node.querySelector('[data-kcv-fabric]');
    if (fabricNode) {
      fabricNode.hidden = !fabric;
      var swatch = fabricNode.querySelector('img');
      if (fabric) {
        swatch.hidden = false; swatch.onerror = function () { swatch.hidden = true; }; swatch.src = fabric.img;
        fabricNode.querySelector('span').replaceChildren(doc.createTextNode(t('Fabric: ', 'القماش: ')), el('bdi', '', fabric.name));
      } else swatch.removeAttribute('src');
    }
    var img = node.querySelector('.kcv-sheet__media img');
    if (image) {
      var next = 0;
      img.onerror = function () { next += 1; if (images[next]) img.src = sized(images[next], 480); else img.hidden = true; };
      img.src = sized(image, 480); img.alt = name; img.hidden = false;
    } else { img.hidden = true; img.removeAttribute('src'); }
    node.querySelector('.kcv-sheet__media').classList.toggle('is-empty', !image);
    node.querySelector('.kcv-sheet__paid dt').textContent = isSet ? t('Set price', 'سعر الطقم') : t('Price', 'السعر');
    paintPrice(amount);
    paintDelivery(null, ctx);
    node.querySelector('[data-kcv-checkout-form] button').textContent = t('Checkout', 'إتمام الطلب');
    node.querySelector('[data-kcv-view]').textContent = t('View cart', 'عرض السلة');
    terms(node.querySelector('.kcv-sheet__terms'));
    node.dataset.route = eta.route;
    setActions(true);
  }
  function variantLabel(line) {
    var title = line && line.variant_title;
    if (!title || /^Default\x20Title$|\(D\s?#/.test(title)) return '';
    return String(title).split(' · ').filter(function (part) { return !/(^|\s)(SAR|SR)$|^\d[\d,.]*\s*(SAR|SR)$|ر\.?\s?س/.test(part.trim()); }).join(' · ');
  }
  // §1.13: Checkout filled + View cart as a text link; without Checkout, View cart is the one filled button and the note
  // under the price says why (the terms line belongs to Checkout, so it is hidden with it).
  var HOLD = {
    confirming: ['Checkout opens as soon as we confirm the price.', 'يتاح إتمام الطلب فور تأكيد السعر.'],
    still: ['Still confirming. Open your cart', 'ما زلنا نؤكد السعر. افتح السلة'],
    options: ['One item needs its options finished before checkout.', 'إحدى القطع تحتاج إلى إكمال خياراتها قبل إتمام الطلب.'],
    // build-1 W6: the same words as the cart's hold (snippets/dpo-order-safety.liquid), with the studio link under them
    studio: ['Checkout opens once every item has a price.', 'يتاح إتمام الطلب بعد تحديد سعر كل قطعة.'],
    review: ['Review your cart before checkout.', 'راجع سلتك قبل إتمام الطلب.']
  };
  // build-1 W6: the product page of a made-to-order base at SAR 0, opening its 3D studio (the product pages' ?studio=1 entry).
  function studioUrl(item) {
    var handle = String((item && item.handle) || '');
    return /^[a-z0-9][a-z0-9-]*$/i.test(handle) ? root() + 'products/' + handle + '?studio=1' : '';
  }
  function setActions(checkout, reason, item) {
    if (!sheet) return;
    sheet.querySelector('[data-kcv-checkout-form]').hidden = !checkout;
    var view = sheet.querySelector('[data-kcv-view]');
    view.className = checkout ? 'kcv-link kcv-sheet__view' : 'kcv-btn kcv-btn--primary kcv-sheet__view';
    var hold = sheet.querySelector('[data-kcv-hold]'), copy = !checkout && (HOLD[reason] || HOLD.review);
    hold.hidden = !copy;
    // the note's text span (the hold is a flex row: icon + text); the studio link goes on its own line inside the text
    var note = hold.querySelector('span');
    note.textContent = copy ? t(copy[0], copy[1]) : '';
    var href = !checkout && reason === 'studio' ? studioUrl(item) : '';
    if (href) {
      var link = el('a', null, t('Open the 3D studio to see its price', 'افتح الاستوديو ثلاثي الأبعاد لمعرفة السعر'));
      link.setAttribute('data-kcv-hold-studio', '');
      link.href = href;
      link.addEventListener('click', function () { if (flush) flush(); });
      note.appendChild(link);
    }
    sheet.querySelector('.kcv-sheet__terms').hidden = !checkout;
  }
  // Checkout is offered only when every line is priced (the same rule as dpo-order-safety and the wallets).
  // Why not: 'confirming' while the added lines have no price yet (the sheet shows "Confirming…"), 'studio' (build-1 W6)
  // when a line is a made-to-order base at SAR 0 (dpo-order-safety holds checkout on the cart for it, and the cart line
  // links to its 3D studio), 'options' when only lines that are still being priced remain, 'review' for a quote line or an
  // unread cart. A configuration variant DPO is still pricing has a "(D#…)" title; any other unpriced line is a base.
  function isFreshConfiguration(item) { return /\(D\s?#/.test(String((item && item.variant_title) || '')); }
  function guardCheckout(cart, paid, exhausted) {
    var items = cart && Array.isArray(cart.items) ? cart.items : null;
    if (!items || !items.length) { setActions(false, 'review'); return 'review'; }
    var unpriced = items.filter(function (item) { return item.handle === 'fully-custom-order' || !(Number(item.final_price) > 0); });
    if (!unpriced.length) { setActions(true); return ''; }
    var quote = unpriced.some(function (item) { return item.handle === 'fully-custom-order'; });
    var base = unpriced.filter(function (item) { return item.handle !== 'fully-custom-order' && !isFreshConfiguration(item); })[0] || null;
    var reason = quote ? 'review' : (unpriced.some(isFreshConfiguration) && !(Number(paid) > 0) ? (exhausted ? 'still' : 'confirming') : (base ? 'studio' : 'options'));
    setActions(false, reason, base);
    return reason;
  }
  // Arabic page, Latin-only name (an English add, or an adopter's English displayName): the localized store name.
  function localizeName(lines, result, picked) {
    if (!ar() || !sheet) return Promise.resolve();
    var nameNode = sheet.querySelector('.kcv-sheet__name');
    if (arabicText.test(nameNode.textContent || '')) return Promise.resolve();
    var first = picked[0] || lines[0] || {}, design = first.properties && first.properties._klik_design;
    var isSet = !!(result && result.setId) || lines.length > 1;
    if (isSet && design && /^[a-z0-9-]+$/.test(design)) {
      return win.fetch(root() + 'products/' + design + '.js', { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.json() : null; }).then(function (product) {
        if (product && arabicText.test(product.title || '')) { nameNode.textContent = displayName(product.title); sheet.querySelector('.kcv-sheet__media img').alt = nameNode.textContent; }
      }).catch(function () {});
    }
    if (!isSet && arabicText.test(first.product_title || '')) {
      nameNode.textContent = displayName(first.product_title);
      var what = sheet.querySelector('.kcv-sheet__what'), label = variantLabel(first);
      if (label && !arabicText.test(what.textContent || '') ) { what.textContent = label; what.hidden = false; }
    }
    return Promise.resolve();
  }
  function open() {
    var node = build();
    if (typeof node.showModal !== 'function') return false;
    returnFocus = doc.activeElement;
    doc.dispatchEvent(new CustomEvent('cart:close'));
    if (!node.open) node.showModal();
    doc.documentElement.classList.add('kcv-sheet-open');
    var title = node.querySelector('#KcvSheetTitle');
    if (title) title.focus({ preventScroll: true });
    return true;
  }
  function read(fresh) {
    var store = win.KlikCart;
    return store && typeof store.get === 'function'
      ? store.get({ fresh: fresh })
      : win.fetch(root() + 'cart.js', { credentials: 'same-origin', cache: 'no-store' }).then(function (r) { return r.json(); });
  }

  /* build-3 track B, task 4 (28 Oct 2026): the order discount can reach the cart after the sheet opened. klik-campaign.js
     applies the campaign code (LAMMA10 now, WHITE15 from 19 Nov) after a session's first add and then says
     klik:campaign:applied (seen: TV set EN 3,542.41 on the sheet, 3,188.17 at checkout). The sheet then reads the cart again
     and paints the amount, the deal line, the delivery line and the Checkout guard from it (only from its own fresh read:
     a cart:updated can carry an older cart, the sheet's own first read among them). While the code is still on its way
     (the estimate counted it, the first cart read does not carry it yet, the session has not confirmed it) the estimate
     stays on screen, marked as an estimate, for 3.5 s at most, so the price does not jump up and back down; adopters that
     pass their own price (pricePaidCents: the studios) show it first and drop to the discounted amount when the code
     lands. One sheet serves every add: each add has its number, and a read made for an earlier add, or one that answers
     after a newer read, never paints. */
  var adds = 0, onDiscount = null;
  function discountOf(cart) { return orderDiscounts(cart).reduce(function (total, app) { return total + Number(app.total_allocated_amount); }, 0); }
  function campaignComing(cart) {
    var config = null;
    try { config = JSON.parse((doc.querySelector('[data-kc-config]') || {}).textContent || 'null'); } catch (_) {}
    if (!config || config.autoApply !== true || config.discountClass !== 'ORDER' || !config.code) return false;
    try { if (win.klikCampaign && typeof win.klikCampaign.state === 'function' && win.klikCampaign.state() !== 'active') return false; } catch (_) { return false; }
    if (((cart && cart.discount_codes) || []).some(function (d) { return d && d.code; })) return false;
    var flag = '';
    try { flag = win.sessionStorage.getItem('klik-campaign-applied:' + config.code) || ''; } catch (_) {}
    return flag === '' || flag === 'pending';
  }
  function KlikCartAdded(result, ctx) {
    ctx = ctx || {};
    var lines = linesOf(result);
    var payload = payloadFor(lines, result, ctx);
    var pub = publisher(payload);
    var amount = estimate(lines, result);
    var opened = false;
    try { fill(lines, result, ctx, amount); opened = open(); } catch (error) { opened = false; }
    if (!opened) { pub.send(amount.paid); win.location.assign(root() + 'cart'); return Promise.resolve({ opened: false, payload: payload }); }
    flush = function () { pub.send(amount.paid); };
    pub.arm(function () { return amount.paid; });
    var mine = sheet, my = ++adds, reads = 0, painted = 0, hold = 0;
    var current = function () { return my === adds && sheet === mine && !!sheet.open; };
    var paintCart = function (cart, n) {
      if (!current() || n < painted || !cart || !Array.isArray(cart.items)) return false;
      painted = n; win.clearTimeout(hold);
      var exact = settle(lines, cart);
      exact.reason = guardCheckout(cart, exact.paid);
      amount = exact;
      paintPrice(exact); paintDelivery(cart, ctx);
      return true;
    };
    if (onDiscount) doc.removeEventListener('klik:campaign:applied', onDiscount);
    onDiscount = function () {
      if (!current()) return;
      var n = ++reads;
      read(true).then(function (cart) { paintCart(cart, n); }).catch(function () {});
    };
    doc.addEventListener('klik:campaign:applied', onDiscount);
    var first = ++reads;
    return read(true).then(function (cart) {
      if (win.KlikCart && win.KlikCart.paintCount) win.KlikCart.paintCount(cart);
      var exact = settle(lines, cart);
      exact.reason = guardCheckout(cart, exact.paid);
      var coming = amount.campaign && amount.paid > 0 && exact.paid > amount.paid && !discountOf(cart) && campaignComing(cart);
      if (coming && current() && first >= painted) hold = win.setTimeout(function () { paintCart(cart, first); }, 3500);
      else if (!paintCart(cart, first) && first >= painted) amount = exact;
      pub.send(exact.paid);
      localizeName(lines, result, exact.picked);
      // A line that is still being priced (a new configuration variant): the cart's backoff (300 ms → 2 s, about 20 s in
      // all, klik-native-cart-display.js), then "Still confirming — open cart" with View cart as the one button.
      if (!(exact.paid > 0) && exact.reason === 'confirming') {
        var delays = [300, 600, 1000, 1500, 2000, 2000, 2000, 2000, 2000, 2000, 2000, 2000], step = 0;
        var poll = function () {
          if (!current() || amount.paid > 0) return;
          if (step >= delays.length) { amount.reason = guardCheckout(cart, 0, true); paintPrice(amount); return; }
          win.setTimeout(function () {
            if (!current() || amount.paid > 0) return;
            read(true).then(function (later) {
              cart = later || cart;
              var again = settle(lines, later);
              again.reason = guardCheckout(later, again.paid);
              if (again.paid > 0 || again.reason !== 'confirming') { amount = again; paintPrice(again); if (again.paid > 0) pub.send(again.paid); return; }
              step += 1; poll();
            }).catch(function () { step += 1; poll(); });
          }, delays[step]);
        };
        poll();
      }
      doc.dispatchEvent(new CustomEvent('klik:cart-added', { detail: { result: result, ctx: ctx, cart: cart, payload: payload } }));
      // Motion rebuilds its drawer only on cart:build / ajaxProduct:added, so a drawer opened later (cart:open) would show the
      // cart from before this add. Rebuild it now (one /cart?view=ajax read), before cart:updated re-seeds the shared store.
      if (doc.getElementById('CartDrawerForm')) doc.dispatchEvent(new CustomEvent('cart:build'));
      doc.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
      return { opened: true, payload: payload, cart: cart, paidCents: exact.paid };
    }).catch(function () {
      guardCheckout(null, amount.paid);
      pub.send(amount.paid);
      doc.dispatchEvent(new CustomEvent('klik:cart-added', { detail: { result: result, ctx: ctx, cart: null, payload: payload } }));
      return { opened: true, payload: payload, cart: null };
    });
  }
  // W7: the clock arrived while the sheet was open: its made-to-order line gets the date
  doc.addEventListener('klik:eta-ready', function () {
    var node = sheet && sheet.open && sheet.querySelector('.kcv-eta');
    if (node && node.dataset.route === 'custom') node.textContent = datedLine();
  });

  /* ---------- the order note (build-3 track B, task 2, 28 Oct 2026) ----------
     klik-native-dpo-properties.js keeps the staff's fabric-photo block ("[KLIK FABRIC PHOTOS / صور الأقمشة]" … "[/KLIK
     FABRIC PHOTOS]": each line's fabric photo links) at the end of cart.note, and writes the whole note into every field
     named "note", so a form submit keeps it. The shopper now sees and edits only their own words: the box they type in has
     no name, and the field named "note" is hidden next to it, holding their words + the block. The cart page renders
     both (sections/main-cart.liquid); the drawer's single box (snippets/cart-drawer.liquid) is split here. Each keystroke
     rewrites the hidden field and tells klik-native-dpo-properties.js (its input listener on the field named "note"); the
     box's change tells Motion (theme.cart.updateNote, bound to the named field), so Checkout, the drawer and the wallets
     carry the block exactly as before. Same two markers and rule as klik-native-dpo-properties.js fabricPhotoNote: a
     note it cannot read (no end marker, two blocks) is shown whole. */
  var NOTE_OPEN = '[KLIK FABRIC PHOTOS / صور الأقمشة]', NOTE_CLOSE = '[/KLIK FABRIC PHOTOS]';
  function noteParts(note) {
    var s = String(note == null ? '' : note), a = s.indexOf(NOTE_OPEN), b = a < 0 ? -1 : s.indexOf(NOTE_CLOSE, a);
    if (a < 0 || b < 0 || s.indexOf(NOTE_OPEN, a + NOTE_OPEN.length) >= 0) return { own: s, block: '' };
    var before = s.slice(0, a).replace(/\s+$/, ''), after = s.slice(b + NOTE_CLOSE.length).replace(/^\s+/, '');
    return { own: before + (before && after ? '\n' : '') + after, block: s.slice(a, b + NOTE_CLOSE.length) };
  }
  function noteJoin(own, block) {
    own = String(own || '').replace(/\s+$/, '');
    return block ? own + (own ? '\n\n' : '') + block : own;
  }
  function bindNote(own, full) {
    if (!own || !full || own.__klikNote) return;
    own.__klikNote = true;
    own.addEventListener('input', function () {
      full.value = noteJoin(own.value, noteParts(full.value).block);
      full.dispatchEvent(new Event('input'));
    });
    own.addEventListener('change', function () {
      full.value = noteJoin(own.value, noteParts(full.value).block);
      full.dispatchEvent(new Event('change'));
    });
  }
  function splitNotes() {
    Array.prototype.forEach.call(doc.querySelectorAll('textarea[data-klik-note-own]'), function (own) {
      var form = own.form || own.closest('form');
      bindNote(own, form && form.querySelector('[name="note"][data-klik-note-full]'));
    });
    Array.prototype.forEach.call(doc.querySelectorAll('#CartDrawerForm textarea[name="note"]:not([data-klik-note-full])'), function (full) {
      var own = doc.createElement('textarea');
      own.className = full.className;
      own.rows = full.rows || 3;
      if (full.id) { own.id = full.id; full.removeAttribute('id'); }
      own.setAttribute('data-klik-note-own', '');
      own.value = noteParts(full.value).own;
      // (klik-v2-cart.css draws ".kcv-drawer textarea.cart-notes" with display:block!important; a style attribute wins)
      full.hidden = true;
      full.style.setProperty('display', 'none', 'important');
      full.tabIndex = -1;
      full.setAttribute('aria-hidden', 'true');
      full.setAttribute('data-klik-note-full', '');
      full.parentNode.insertBefore(own, full);
      bindNote(own, full);
    });
  }
  // the clock is not needed for the first paint here (product pages and the cart page load it themselves): idle time
  if (typeof win.requestIdleCallback === 'function') win.requestIdleCallback(loadEta, { timeout: 3000 }); else win.setTimeout(loadEta, 1500);
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', splitNotes, { once: true }); else splitNotes();
  KlikCartAdded.close = close;
  // For tests and adopters: the amount checkout charges for these lines in this cart (cents).
  KlikCartAdded.paidFor = function (lines, cart) { return settle(linesOf(lines), cart).paid; };
  win.KlikCartAdded = KlikCartAdded;
}(typeof window === 'undefined' ? null : window));
